// 对于异步操作，预定义发起(后缀`REQ`)、成功(无后缀)、失败(后缀`FAIL`) 三种状态
// 方便业务使用

import _ from 'lodash'

const resourceMaker = (ajaxResources=[], normalResources=[], prefix='') => {
  let ret = _.reduce(ajaxResources, (ret, val) => {
    ret[`${val}`] = `${prefix}${val}`
    ret[`${val}_REQ`] = `${prefix}${val}_REQ`
    ret[`${val}_FAIL`] = `${prefix}${val}_FAIL`
    return ret
  }, {})

  ret = _.reduce(normalResources, (ret, val) => {
    ret[`${val}`] = `${prefix}${val}`
    return ret
  }, ret)

  return ret
}

// 全局动作
export const global = resourceMaker([], [
  'SET_TITLE'
])

export const todo = resourceMaker([
  'GET_CONFIGINFO',
  'UPDATE_CONFIGINFO',
  'CREATE',
  'DELETE',
  'UPDATE',
  'UPDATE_ORDER',
  'GET_ALL'
], 'TODO_')

export const error = resourceMaker([], [
  'SHOW',
  'HIDE'
], 'ERROR_')

export const auth = resourceMaker([], [
  'GET_INITINFO'
], 'AUTH_')



/** WEBPACK FOOTER **
 ** ./src/vuex/types.js
 **/